export interface IPAY_COMMISSION_FORMULA {
  basicPay: number;
  fitmentFactor: number;
  hraPercentageA: number;
  daPercentage?: number;
}

export const PAY_COMMISSION_FORMULA = ({
  basicPay,
  fitmentFactor,
  hraPercentageA,
  daPercentage = 0,
}: IPAY_COMMISSION_FORMULA) => {
  const baseSalary = Number(basicPay);
  const fitment = Number(fitmentFactor);
  const hraPercent = Number(hraPercentageA);
  const daPercent = Number(daPercentage);

  if (
    baseSalary < 0 ||
    fitment <= 0 ||
    hraPercent < 0 ||
    hraPercent > 100 ||
    daPercent < 0 ||
    daPercent > 100
  ) {
    return {
      expectedDA: 0,
      netSalary: 0,
      hraPercentage: 0,
      currentBasicPay: baseSalary,
      estimatedBasicPay8thCPC: 0,
    };
  }

  const estimatedBasicPay8thCPC = baseSalary * fitment;
  const hraInCity = estimatedBasicPay8thCPC * (hraPercent / 100);
  const expectedDAResult = estimatedBasicPay8thCPC * (daPercent / 100);
  const netSalaryResult =
    estimatedBasicPay8thCPC + expectedDAResult + hraInCity;

  return {
    expectedDA: expectedDAResult,
    netSalary: netSalaryResult,
    hraPercentage: hraInCity,
    currentBasicPay: baseSalary,
    estimatedBasicPay8thCPC,
  };
};
